import { render, staticRenderFns } from "./About.vue?vue&type=template&id=76bd78ab&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=76bd78ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bd78ab",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AboutFeaturedOn: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/AboutFeaturedOn/AboutFeaturedOn.vue').default})
